import React, { useState } from "react";

import { Box, CssBaseline } from "@mui/material";
import { Outlet } from "react-router-dom";

import Header from "./Header";
import Sidebar from "./Sidebar";

const defaultDrawerWidth = 260;
const collapsedDrawerWidth = 84;
const minDrawerWidth = 220;
const maxDrawerWidth = 420;

function MainLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [drawerWidth, setDrawerWidth] = useState(defaultDrawerWidth);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prev) => !prev);
  };

  const handleSidebarCollapseToggle = () => {
    setIsSidebarCollapsed((prev) => !prev);
  };

  const handleSidebarResizeStart = (event) => {
    if (isSidebarCollapsed) {
      return;
    }

    const startX = event.clientX;
    const startWidth = drawerWidth;

    const handleMouseMove = (moveEvent) => {
      const delta = moveEvent.clientX - startX;
      const nextWidth = Math.min(
        maxDrawerWidth,
        Math.max(minDrawerWidth, startWidth + delta)
      );

      setDrawerWidth(nextWidth);
    };

    const handleMouseUp = () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const activeDrawerWidth = isSidebarCollapsed
    ? collapsedDrawerWidth
    : drawerWidth;

  return (
    <Box
      sx={{
        display: "flex",
        bgcolor: "#F5F7FA",
      }}
    >
      <CssBaseline />

      <Header
        drawerWidth={activeDrawerWidth}
        isSidebarCollapsed={isSidebarCollapsed}
        onToggleSidebarCollapse={handleSidebarCollapseToggle}
        handleDrawerToggle={handleDrawerToggle}
      />

      <Sidebar
        drawerWidth={drawerWidth}
        collapsedDrawerWidth={collapsedDrawerWidth}
        isSidebarCollapsed={isSidebarCollapsed}
        onResizeStart={handleSidebarResizeStart}
        mobileOpen={mobileOpen}
        handleDrawerToggle={handleDrawerToggle}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: {
            sm: `calc(100% - ${activeDrawerWidth}px)`,
          },
          minHeight: "100vh",
          mt: 8,
          p: 3,
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}

export default MainLayout;
